import { useEffect } from "react";
import Image, { ImageProps } from "next/image";

interface ProtectedImageProps
  extends Omit<ImageProps, "draggable" | "onContextMenu"> {
  src: string;
  alt: string;
}

export default function ProtectedImage({
  src,
  alt,
  ...props
}: ProtectedImageProps) {
  useEffect(() => {
    // Disable right-click on entire document
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
      return false;
    };

    // Disable common keyboard shortcuts for saving
    const handleKeyDown = (e: KeyboardEvent) => {
      // Ctrl+S or Cmd+S (Save)
      if ((e.ctrlKey || e.metaKey) && e.key === "s") {
        e.preventDefault();
        return false;
      }
      // Ctrl+Shift+I or Cmd+Option+I (DevTools)
      if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === "I") {
        e.preventDefault();
        return false;
      }
      // F12 (DevTools)
      if (e.key === "F12") {
        e.preventDefault();
        return false;
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div
      style={{
        position: "relative",
        userSelect: "none",
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        msUserSelect: "none",
      }}
      onContextMenu={(e) => e.preventDefault()}
      onDragStart={(e) => e.preventDefault()}
    >
      <Image
        src={src}
        alt={alt}
        draggable={false}
        onContextMenu={(e) => e.preventDefault()}
        {...props}
        style={{
          pointerEvents: "none",
          userSelect: "none",
          ...props.style,
        }}
      />
      {/* Transparent overlay to prevent direct image interaction */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "transparent",
        }}
      />
    </div>
  );
}
